var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkloadDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 7.38234C15.9708 7.38234 17.5685 5.84168 17.5685 3.94117C17.5685 2.04066 15.9708 0.5 13.9999 0.5C12.029 0.5 10.4313 2.04066 10.4313 3.94117C10.4313 5.84168 12.029 7.38234 13.9999 7.38234Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 20.6175C15.5497 20.6175 16.806 19.406 16.806 17.9116C16.806 16.4172 15.5497 15.2057 13.9999 15.2057C12.4501 15.2057 11.1938 16.4172 11.1938 17.9116C11.1938 19.406 12.4501 20.6175 13.9999 20.6175Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6755 20.6175C26.2252 20.6175 27.4816 19.406 27.4816 17.9116C27.4816 16.4172 26.2252 15.2057 24.6755 15.2057C23.1257 15.2057 21.8694 16.4172 21.8694 17.9116C21.8694 19.406 23.1257 20.6175 24.6755 20.6175Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32462 20.6175C4.87438 20.6175 6.13071 19.406 6.13071 17.9116C6.13071 16.4172 4.87438 15.2057 3.32462 15.2057C1.77485 15.2057 0.518518 16.4172 0.518518 17.9116C0.518518 19.406 1.77485 20.6175 3.32462 20.6175Z",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3813 7.61761H13.6188V14.9705H14.3813V7.61761Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08716 15.7059C9.39753 9.2784 17.8943 8.42128 23.9128 15.7059",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkloadDark);
export default __webpack_public_path__ + "static/media/workload-dark.d0356b32e043e9d46e333d61acda2362.svg";
export { ForwardRef as ReactComponent };